<div class="header">
  <h3>Inspection Code Setup</h3>
</div>

<div class="row">
  <div class="col form-wrapper">
    <form #engagementForm="ngForm" class="editor-form">
      <div class="mt-2 mb-4">
        <button type="submit"
          class="btn btn-primary mr-2"
          [disabled]="!engagementForm.valid || isLoading"
          (click)="saveChanges()">
          <i class="fa fa-save"></i>
          Save
        </button>
        <button type="button"
          class="btn btn-secondary mr-2"
          (click)="goHome()">
          <i class="fa fa-times"></i>
          Cancel
        </button>
        <small class="form-text text-muted d-inline-flex">Please note: <b class="required px-2">*</b> indicates a required field</small>
      </div>
      <hr />

      @if (engagement) {
        <fieldset class="mb-2" [disabled]="isLoading">
          <legend>Metadata</legend>
          <div class="row">
            <div class="form-group col-md-3">
              <label class="form-label required" for="inspection-year">Inspection Year</label>
              <input type="number" class="form-control" id="inspection-year" name="inspection-year"
                required [(ngModel)]="engagement.inspectionYear" />
            </div>
            <div class="form-group col-md-3">
              <label class="form-label required" for="code">Code</label>
              <input type="text" class="form-control" id="code" name="code"
                required [(ngModel)]="engagement.code" />
            </div>
            <div class="form-group col-md-3">
              <label class="form-label" for="client">Client</label>
              <ng-select [items]="clients"
                [virtualScroll]="true"
                [searchable]="true"
                [loading]="clientsLoading"
                bindLabel="label"
                bindValue="id"
                placeholder="Select one..."
                id="client"
                name="client"
                [(ngModel)]="engagement.clientId"
                (change)="onClientChange()"
                (search)="onClientsSearch($event)"
                (scroll)="onClientsScroll($event)"
                (scrollToEnd)="onClientsScrollToEnd()">
                <ng-template ng-header-tmp>
                  <small class="form-text text-muted">Loaded {{clients.length}} of {{clientsCount}}</small>
                </ng-template>
              </ng-select>
            </div>
            <div class="form-group col-md-3">
              <label class="form-label" for="project">Projects</label>
              <ng-select [items]="availableProjects"
                [virtualScroll]="true"
                [searchable]="true"
                [loading]="projectsLoading"
                bindLabel="label"
                placeholder="Select project..."
                id="project"
                name="project"
                [(ngModel)]="selectedProject"
                [disabled]="!engagement.clientId"
                (change)="addProject()"
                (search)="onProjectsSearch($event)"
                (scroll)="onProjectsScroll($event)"
                (scrollToEnd)="onProjectsScrollToEnd()">
                <ng-template ng-header-tmp>
                  <small class="form-text text-muted">Loaded {{projects.length}} of {{projectsCount}}</small>
                </ng-template>
              </ng-select>
              <table class="table table-striped table-align-middle mb-0 mt-2">
                <tbody>
                  @for (engagementProject of assignedInspectionProjects; track engagementProject) {
                    <tr>
                      <td>
                        <button type="button" class="btn btn-sm btn-primary"
                          (click)="removeProject(engagementProject)">
                          <i class="fa fa-fw fa-trash"></i>
                          <span class="sr-only">Remove project</span>
                        </button>
                      </td>
                      <td>{{engagementProject.project?.label || engagementProject.project?.name || engagementProject.projectId}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-3">
              <label class="form-label" for="workspace-name">Workspace Name</label>
              <ng-select [items]="availableAptCaws"
                [virtualScroll]="true"
                [searchable]="true"
                [loading]="aptCawsLoading"
                bindLabel="label"
                placeholder="Select Apt Workspace..."
                id="workspace-name"
                name="workspace-name"
                [(ngModel)]="selectedAptCaw"
                [disabled]="!engagement.clientId"
                (change)="addAptCaw()"
                (search)="onAptCawsSearch($event)"
                (scroll)="onAptCawsScroll($event)"
                (scrollToEnd)="onAptCawsScrollToEnd()">
                <ng-template ng-header-tmp>
                  <small class="form-text text-muted">Loaded {{aptCaws.length}} of {{aptCawsCount}}</small>
                </ng-template>
              </ng-select>
              <table class="table table-striped table-align-middle mb-0 mt-2">
                <tbody>
                  @for (engagementAptCaw of assignedAptCaws; track engagementAptCaw) {
                    <tr>
                      <td>
                        <button type="button" class="btn btn-sm btn-primary"
                          (click)="removeAptCaw(engagementAptCaw)">
                          <i class="fa fa-fw fa-trash"></i>
                          <span class="sr-only">Remove workspace</span>
                        </button>
                      </td>
                      <td>{{engagementAptCaw.aptCaw?.label || engagementAptCaw.aptCaw?.name || engagementAptCaw.aptCawId}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            <div class="form-group col-md-3">
              <label class="form-label" for="client-fiscal-year-end">Client Fiscal Year End</label>
              <div class="input-group">
                <input type="text" class="form-control datepicker" id="client-fiscal-year-end" name="client-fiscal-year-end"
                  placeholder="Select date..."
                  ngbDatepicker #fiscalYearDate="ngbDatepicker"
                  [(ngModel)]="engagement.clientFiscalYearEnd"
                  (click)="fiscalYearDate.open()" />
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="button" (click)="fiscalYearDate.toggle()">
                    <i class="fa fa-calendar"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group col-md-3">
              <label class="form-label" for="entity-type">Entity Type</label>
              <input type="text" class="form-control" id="entity-type" name="entity-type"
                [(ngModel)]="engagement.clientEntityType" />
            </div>
            <div class="form-group col-md-3">
              <label class="form-label" for="engagement-type">Engagement Type</label>
              <input type="text" class="form-control" id="engagement-type" name="engagement-type"
                [(ngModel)]="engagement.engagementType" />
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-3">
              <label class="form-label" for="total-engagement-hours">Total Engagement Hours</label>
              <input type="number" class="form-control" id="total-engagement-hours" name="total-engagement-hours"
                [(ngModel)]="engagement.totalEngagementHours" />
            </div>
            <div class="form-group col-md-3">
              <label class="form-label" for="office">Office</label>
              <select class="custom-select" id="office" name="office"
                [ngModel]="engagement.officeId"
                (ngModelChange)="onOfficeChanged($event)">
                <option [ngValue]="null">Select...</option>
                @for (office of offices; track office.id) {
                  <option [ngValue]="office.id">{{office.id}} - {{office.name}}</option>
                }
              </select>
            </div>
            <div class="form-group col-md-3">
              <label class="form-label" for="region">Region</label>
              <input type="text" class="form-control" id="region" name="region"
                [ngModel]="engagement.regionCode" readonly />
            </div>
            <div class="form-group col-md-3">
              <label class="form-label" for="business-line">Business Line</label>
              <select class="custom-select" id="business-line" name="business-line"
                [(ngModel)]="engagement.businessLineId">
                <option [ngValue]="null">Select...</option>
                @for (businessLine of businessLines; track businessLine.id) {
                  <option [ngValue]="businessLine.id">{{businessLine.name}}</option>
                }
              </select>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-3">
              <label class="form-label" for="industry-name">Industry Name</label>
              <ng-select [items]="availableIndustries"
                bindLabel="name"
                placeholder="Select Industry..."
                id="industry-name"
                name="industry-name"
                [(ngModel)]="selectedIndustry"
                (change)="addIndustry()">
              </ng-select>
              <table class="table table-striped table-align-middle mb-0 mt-2">
                <tbody>
                  @for (engagementIndustry of assignedIndustries; track engagementIndustry) {
                    <tr>
                      <td>
                        <button type="button" class="btn btn-sm btn-primary"
                          (click)="removeIndustry(engagementIndustry)">
                          <i class="fa fa-fw fa-trash"></i>
                          <span class="sr-only">Remove industry</span>
                        </button>
                      </td>
                      <td>{{industryLabel(engagementIndustry)}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            <div class="form-group col-md-3">
              <label class="form-label" for="market-cap">Market Cap (thousands)</label>
              <input type="number" class="form-control" id="market-cap" name="market-cap"
                [(ngModel)]="engagement.marketCap" />
            </div>
            <div class="form-group col-md-3">
              <label class="form-label" for="start-of-inspection-fieldwork">Start of Inspection Fieldwork</label>
              <div class="input-group">
                <input type="text" class="form-control datepicker" id="start-of-inspection-fieldwork" name="start-of-inspection-fieldwork"
                  placeholder="Select date..."
                  ngbDatepicker #startFieldworkDate="ngbDatepicker"
                  [(ngModel)]="engagement.startOfInspectionFieldWork"
                  (click)="startFieldworkDate.open()" />
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="button" (click)="startFieldworkDate.toggle()">
                    <i class="fa fa-calendar"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group col-md-3">
              <label class="form-label" for="end-of-inspection-fieldwork">Closing Meeting Date</label>
              <div class="input-group">
                <input type="text" class="form-control datepicker" id="end-of-inspection-fieldwork" name="end-of-inspection-fieldwork"
                  placeholder="Select date..."
                  ngbDatepicker #endFieldworkDate="ngbDatepicker"
                  [(ngModel)]="engagement.endOfInspectionFieldWork"
                  (click)="endFieldworkDate.open()" />
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="button" (click)="endFieldworkDate.toggle()">
                    <i class="fa fa-calendar"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        <hr />
        <fieldset class="mb-2" [disabled]="isLoading">
          <legend>Inspection Team</legend>

          <div class="row">
            <div class="col-sm-6">
              <div class="form-group row">
                <label class="form-label col-sm-3 required" for="engagement-inspection-lead">Team Captain</label>
                <div class="col">
                  <app-employee-search [employeeList]="employees"
                    (onChange)="addTeamCaptainToTeamIfNecessary()"
                    [(model)]="engagement.inspectionLeadId"
                    [errorMessage]="'Team Captain is invalid.'"
                    [required]="true"
                    (onSearch)="searchEmployees($event)">
                  </app-employee-search>
                </div>
              </div>
              <div class="form-group row">
                <label class="form-label col-sm-3" for="available-team-members-it">Available team members</label>
                <div class="col">
                  <app-employee-search [employeeList]="availableInspectionEmployees"
                    [(model)]="selectedInspectionTeamId"
                    (buttonClick)="addInspectionTeamMember()"
                    [showButton]="true"
                    [buttonScreenReaderText]="'Add to inspection team'"
                    (onSearch)="searchEmployees($event)">
                  </app-employee-search>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">Assigned inspection team members</label>
            <table class="table table-striped table-align-middle mb-0">
              <thead>
                <tr>
                  <th style="width: 3rem;"></th>
                  <th>Name</th>
                  <th>Specialty Reviewer</th>
                  <th>Topics &amp; Standards Assigned</th>
                </tr>
              </thead>
              <tbody>
                @if (assignedInspectionTeamMembers.length == 0) {
                  <tr>
                    <td colspan="4">
                      <span class="d-block p-2">
                        <i class="fa fa-ban text-danger"></i>
                        Engagement contains no inspection team members&hellip;
                      </span>
                    </td>
                  </tr>
                }
                @for (member of assignedInspectionTeamMembers; track member; let i = $index) {
                  <tr>
                    <td>
                      @if (member.employeeId != engagement.inspectionLeadId) {
                        <button type="button"
                          class="btn btn-sm btn-primary"
                          (click)="removeInspectionTeamMember(member)">
                          <i class="fa fa-fw fa-trash"></i>
                        </button>
                      }
                      @if (member.employeeId == engagement.inspectionLeadId) {
                        <span class="bdo-tag bdo-tag-dark">TC</span>
                      }
                    </td>
                    <td>{{member.employee?.fullName}}</td>
                    <td>
                      <select class="custom-select"
                        id="specialty-reviewer-type-{{i}}"
                        name="specialty-reviewer-type-{{i}}"
                        [(ngModel)]="member.specialtyReviewerTypeId">
                        <option [ngValue]="null">Select one...</option>
                        @for (type of availableSpecialtyReviewerTypes(member.specialtyReviewerTypeId); track type) {
                          <option [ngValue]="type.id">{{type.name}}</option>
                        }
                      </select>
                    </td>
                    <td>
                      <button type="button"
                        class="btn btn-sm btn-secondary mb-2"
                        (click)="addTopicRow(member)">
                        <i class="fa fa-plus"></i> Add Topic
                      </button>
                      <table class="table table-striped table-align-middle mb-0">
                        <tbody>
                          @for (topicRow of getTeamMemberTopics(member); track topicRow; let j = $index) {
                            <tr>
                              <td style="width: 3rem;">
                                <button type="button"
                                  class="btn btn-sm btn-primary"
                                  (click)="removeTopicRow(topicRow)">
                                  <i class="fa fa-fw fa-trash"></i>
                                </button>
                              </td>
                              <td style="width: 28%;">
                                <ng-select id="topic-{{i}}-{{j}}"
                                  name="topic-{{i}}-{{j}}"
                                  placeholder="Select topic..."
                                  [items]="topics"
                                  bindLabel="name"
                                  bindValue="id"
                                  [(ngModel)]="topicRow.topicId"
                                  (change)="onTopicChange(topicRow, member)">
                                </ng-select>
                              </td>
                              <td>
                                <ng-select id="standards-{{i}}-{{j}}"
                                  name="standards-{{i}}-{{j}}"
                                  placeholder="Select standards..."
                                  [multiple]="true"
                                  [searchable]="true"
                                  [closeOnSelect]="false"
                                  [ngModel]="standardSelections[topicRow.id]"
                                  (ngModelChange)="onStandardsChange(topicRow, $event)">
                                  @for (standard of standards; track standard.id) {
                                    <ng-option [value]="standard.id">{{standard.name}}</ng-option>
                                  }
                                </ng-select>
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </fieldset>

        <hr />
        <fieldset class="mb-2" [disabled]="isLoading">
          <legend>Engagement Team</legend>

          <div class="row">
            <div class="col-sm-6">
              <div class="form-group row">
                <label class="form-label col-sm-3" for="available-team-members-et">Available team members</label>
                <div class="col">
                  <app-employee-search [employeeList]="availableEngagementEmployees"
                    [(model)]="selectedEngagementTeamId"
                    (buttonClick)="addEngagementTeamMember()"
                    [showButton]="true"
                    [buttonScreenReaderText]="'Add to engagement team'"
                    (onSearch)="searchEmployees($event)">
                  </app-employee-search>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">Assigned engagement team members</label>
            <table class="table table-striped table-align-middle mb-0">
              <thead>
                <tr>
                  <th style="width: 3rem;"></th>
                  <th style="width: 40%;">Name</th>
                  <th style="width: 6rem;">Hours</th>
                  <th style="width: 40%;">
                    Role
                    @if (assignedEngagementTeamMembers.length) {
                      <span class="text-danger">*</span>
                    }
                  </th>
                </tr>
              </thead>
              <tbody>
                @if (assignedEngagementTeamMembers.length == 0) {
                  <tr>
                    <td colspan="4">
                      <span class="d-block p-2">
                        <i class="fa fa-ban text-danger"></i>
                        Engagement contains no engagement team members&hellip;
                      </span>
                    </td>
                  </tr>
                }
                @for (teamMember of assignedEngagementTeamMembers; track teamMember.id; let i = $index) {
                  <tr>
                    <td>
                      <button type="button"
                        class="btn btn-sm btn-primary"
                        (click)="removeEngagementTeamMember(teamMember)">
                        <i class="fa fa-fw fa-trash"></i>
                        <span class="sr-only">Remove engagement team member</span>
                      </button>
                    </td>
                    <td>{{teamMember.employee?.fullName}}</td>
                    <td>
                      <input type="text"
                        id="engagement-teamMember-{{i}}-hours"
                        name="engagement-teamMember-{{i}}-hours"
                        class="form-control"
                        pattern="^-?\d*[.,]?\d{0,2}$"
                        [(ngModel)]="teamMember.hours" />
                    </td>
                    <td>
                      <select class="custom-select"
                        id="engagement-teamMember-{{i}}-role"
                        name="engagement-teamMember-{{i}}-role"
                        [(ngModel)]="teamMember.inspectionTeamRoleId" required>
                        <option [ngValue]="null">Select one...</option>
                        @for (role of teamMemberRoles; track role.id) {
                          <option [ngValue]="role.id">{{role.name}}</option>
                        }
                      </select>
                      <small class="form-text text-danger validation-message">Role is invalid.</small>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </fieldset>
      }
    </form>
  </div>
</div>
